import {
  BaseObjectDTO, ProcedureDTO, OrganizationalUnitDTO, ProfileDTO, InboxDTO, DossierDTO
} from '../../../api/plyca-dtos';
import { ObjectContextDTO, WorkDataDTO } from '../../../api/plyca-dtos-v2';
import { ProcurementProject } from '../../../api/contract-notice-dto';


/*export class AssignManagerDTO implements BaseEntityDTO {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  identifier: any;
  task: TaskDTO;
  award: AwardDTO;
  contract: ContractDTO;
  amount: number;
  approvalDate: Date;
  registrationDate: Date;
  measurementDate: Date;
  registerNumberContractModificacion: string;
  observation: string;
  document: DocumentDTO;
}*/

export interface WorkTaskAssignmentDTO extends BaseObjectDTO<string> {
  identifier: string;
  taskAssignment: TaskAssignmentDTO;
}

export enum InboxRole {
  DISPATCHER = 'DISPATCHER',
  SIGNER = 'SIGNER'
}

export interface ProfileAssignmentDTO {
  assigned: boolean;
  inbox: InboxDTO;
  inboxRole: InboxRole;
  locked: Boolean;
  profile: ProfileDTO;
}

export interface TaskAssignmentDTO extends BaseObjectDTO<string> {
  context?: ObjectContextDTO;
  reassignLoadType: ReassignLoadType;
  deleteHistory: Boolean;
  reassignByProfile: Boolean;
  reassignActionType: ReassignActionType;
  procedureSelected: ProcedureDTO;
  organizationalUnit: OrganizationalUnitDTO;
  listProfileAssignments: Array<ProfileAssignmentDTO>;
}

/*export interface TaskAssignmentIdDTO
  extends BaseSubordinateIdDTO<ReassignLoadType, ProjectEntityDTO> { }*/

export enum ReassignLoadType {
  DEFAULT = 'DEFAULT',
  CARGA_VARIABLES = 'CARGA_VARIABLES',
  // CARGA_PROTOCOLO_HUECOS = 'CARGA_PROTOCOLO_HUECOS',
  // CARGA_PROTOCOLO_TODOS = 'CARGA_PROTOCOLO_TODOS',
  CARGA_PROTOCOLO = 'CARGA_PROTOCOLO',
  CARGA_USUEXP = 'CARGA_USUEXP'
}

export enum ReassignActionType {
  UNDEFINED = 'UNDEFINED',
  SELECTED_PROCEDURE = 'SELECTED_PROCEDURE',
  NEW_AND_SELECTED_PROCEDURE = 'NEW_AND_SELECTED_PROCEDURE',
  NEW_PROCEDURE = 'NEW_PROCEDURE',
  ALL_PROCEDURE = 'ALL_PROCEDURE'
}

/**
 * Datos de configuracion de la apertura de la pantalla
 */
export class TaskAssignmentComponentConfig {
  /**
   * Identificador de tramite
   */
  procedure: ProcedureDTO;
  project: DossierDTO;

}

/**
 * Clase asociada al contexto de configuracion de la tarea o procedimiento
 */
export class TaskAssignmentContextConfig {
  checkUser: WorkDataDTO;
  isVisibleButtonReassign: WorkDataDTO;
  isVisiblePanelActions: WorkDataDTO;
  // reassignByProfiles: WorkDataDTO;
  isVisibleReassignByProfiles: WorkDataDTO;
  isVisibleSearchOrganizationalUnit: WorkDataDTO;
  deleteHistory: WorkDataDTO;
  hideProfilesProperty: WorkDataDTO;
  manageDispatcher: WorkDataDTO;
  manageCurrentProcedure: WorkDataDTO;
  isLoadByUsuExp: WorkDataDTO;
  lockProfilesTaskParameter: WorkDataDTO;
  hideProfilesTaskParameter: WorkDataDTO;
  organizationalUnitTaskParameter: WorkDataDTO;
  divisionTaskParameter: WorkDataDTO;
  exceptionAMSeveralAdj: WorkDataDTO;
}

/**
 * Objeto asociado a las filas de la tabla de asignaciones: asignaciones por perfil
 */
export class ProfileTableRowModel {
  profile: ProfileDTO;
  /**
   * Asociado al check de perfil
   */
  checked: boolean;
  dispatcher: ProfileAssignmentDTO;
  signer: ProfileAssignmentDTO;
}

